import React, { useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField
} from "@mui/material";
import EventBus from '../../utils/EventBus.js'
import HubEventNames from '../EventNames.js'
import ShareArticleDistributionControls from "./ShareArticleDistributionControls.js";

const emptyDistribution = () => ({
  roles: [],
  ownershipContactTypes: [],
  facilityContactTypes: [],
  emailList: [],
  emailListInvalid: false
})

export default function ShareArticleDialog() {
  const [subject, setSubject] = useState('')
  const [distribution, setDistribution] = useState(emptyDistribution)

  const [loading, setLoading] = useState(false)

  const [open, setOpen] = useState(false)
  const [payload, setPayload] = useState()

  const openDialog = useCallback((payload) => {
    setPayload(payload)
    setSubject(payload.subject)
    setOpen(true)
  }, [])


  const handleClose = useCallback((payloadOverride) => {
    const activePayload = payloadOverride ?? payload

    setDistribution(emptyDistribution())
    if (activePayload?.onClose) activePayload.onClose();
    setLoading(false)
    setOpen(false)
  }, [payload])

  const close = useCallback((payloadOverride) => {
    handleClose(payloadOverride)
  }, [handleClose])

  useEffect(() => {
    EventBus.on(HubEventNames.OPEN_SHARE_ARTICLE_DIALOG, openDialog)
    EventBus.on(HubEventNames.CLOSE_SHARE_ARITCLE_DIALOG, close)

    return () => {
      EventBus.removeListener(HubEventNames.OPEN_SHARE_ARTICLE_DIALOG, openDialog)
      EventBus.removeListener(HubEventNames.CLOSE_SHARE_ARITCLE_DIALOG, close)
    }
  }, [close, openDialog])

  const handleConfirm = async () => {
    if (!canShare) return;
    setLoading(true)
    try {
      if(payload?.onConfirm) {
        await payload?.onConfirm(
          subject,
          distribution
        );
      }
    } finally {
      setLoading(false)
    }
  };

  const canShare =
    !distribution.emailListInvalid
    && (
      distribution.ownershipContactTypes.length
      || distribution.facilityContactTypes.length
      || distribution.roles.length
      || distribution.emailList.length
    );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>Share Article</DialogTitle>

      <DialogContent dividers>
        <Typography sx={{ mb: 3 }} color="text.secondary">
          This will notify all selected users that a new article has
          been published.
        </Typography>

        {/* Email subject input */}
        <TextField
          label="Email subject"
          placeholder="Enter the email subject"
          size="small"
          fullWidth
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          sx={{ mb: 3 }}
          helperText="This subject will appear in the notification email."
        />

        <ShareArticleDistributionControls
          open={open}
          onDistributionChange={setDistribution}
        />
      </DialogContent>

      <DialogActions>
        <Button size="small" onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button
          size="small"
          variant="contained"
          disabled={!canShare || loading}
          onClick={handleConfirm}
        >
          Preview Email
        </Button>
      </DialogActions>
    </Dialog>
  );
}